import React from 'react';

import { Option, EmptyOption, StyledInfiniteList } from './styles';
import { SelectOption, CustomSelectMenuItemProps } from '../types';

export const SelectOptions = ({
  options,
  onSelect,
  selected,
  CustomItem,
  isLoading,
  hasMore,
  fetchMore,
  noResultsMessage,
}: SelectOptionsProps) => {
  return options.length || isLoading ? (
    <StyledInfiniteList
      isLoading={!!isLoading}
      hasMore={hasMore}
      fetchMore={fetchMore}
      offset={5}
    >
      {options.map((option, i) => (
        <Option
          key={option.value || `option_${i}`}
          onClick={() => onSelect(option)}
          $selected={option.value === selected?.value}
        >
          {CustomItem ? <CustomItem option={option} /> : option.label}
        </Option>
      ))}
    </StyledInfiniteList>
  ) : (
    <EmptyOption>{noResultsMessage || 'No results found'}</EmptyOption>
  );
};

export interface SelectOptionsProps {
  options: SelectOption[];
  selected?: SelectOption;
  CustomItem?: (props: CustomSelectMenuItemProps) => React.JSX.Element;
  onSelect: (option: SelectOption) => void;
  isLoading?: boolean;
  fetchMore?: () => void;
  hasMore?: boolean;
  noResultsMessage?: string;
}
